import { SVGInterface } from "../../interface";

const SlowMotion = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13.0249 9.79005L9.9749 7.50005V16.5L13.0249 14.21L15.9749 12L13.0249 9.79005ZM13.0249 9.79005L9.9749 7.50005V16.5L13.0249 14.21L15.9749 12L13.0249 9.79005ZM13.0249 9.79005L9.9749 7.50005V16.5L13.0249 14.21L15.9749 12L13.0249 9.79005ZM10.9749 4.07005V2.05005C8.9649 2.25005 7.1349 3.05005 5.6549 4.26005L7.0749 5.69005C8.1849 4.83005 9.5149 4.25005 10.9749 4.07005ZM5.6649 7.10005L4.2349 5.68005C3.0249 7.16005 2.2249 8.99005 2.0249 11H4.0449C4.2249 9.54005 4.8049 8.21005 5.6649 7.10005ZM4.0449 13H2.0249C2.2249 15.01 3.0249 16.84 4.2349 18.32L5.6649 16.89C4.8049 15.79 4.2249 14.46 4.0449 13ZM5.6549 19.74C7.1349 20.9501 8.9749 21.75 10.9749 21.9501V19.93C9.5149 19.75 8.1849 19.17 7.0749 18.31L5.6549 19.74ZM21.9749 12C21.9749 17.16 18.0549 21.42 13.0249 21.9501V19.93C16.9449 19.41 19.9749 16.05 19.9749 12C19.9749 7.95005 16.9449 4.59005 13.0249 4.07005V2.05005C18.0549 2.58005 21.9749 6.84005 21.9749 12Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default SlowMotion;
